import api from '@/lib/api';
import type { SiteContentRow, UpsertSiteContentRequest } from '@pms/shared';

/** GET /v1/admin/site-content — stored homepage stat rows. */
export async function fetchSiteContent(): Promise<SiteContentRow[]> {
  const { data } = await api.get<SiteContentRow[]>('/admin/site-content');
  return data;
}

/** PUT /v1/admin/site-content — upsert one stat by key. */
export async function upsertSiteContent(
  body: UpsertSiteContentRequest,
): Promise<SiteContentRow> {
  const { data } = await api.put<SiteContentRow>('/admin/site-content', body);
  return data;
}
